import { FaqCategory, FaqData } from '../../types'

interface FaqSidebarProps {
  faqData: FaqData
}

/**
 * FAQ sidebar component
 * Displays navigation categories and links
 */
export const FaqSidebar = ({ faqData }: FaqSidebarProps) => {
  const renderCategory = (category: FaqCategory) => {
    return (
      <div className="faq-nav-category" key={category.id}>
        <h3 className="faq-nav-category-title">{category.title}</h3>
        <ul className="faq-nav-links">
          {category.items.map((item) => (
            <li key={item.id}>
              <a href={`#${item.id}`}>{item.question}</a>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <aside className="faq-sidebar">
      {faqData.categories.map(renderCategory)}
    </aside>
  )
}
